import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { IconDefinition, IconProp } from '@fortawesome/fontawesome-svg-core';
import styles from './iconWithTooltip.module.scss';
import classnames from 'classnames/bind';
import { Link } from 'react-router-dom';

interface IconWithTooltipProps {
  disabled?: boolean;
  placement?: 'bottom' | 'top' | 'left' | 'right';
  className?: string;
  icon: IconDefinition | IconProp;
  onClick?: () => void;
  tooltipProps?: {
    id: string | number;
    tooltip: React.ReactElement | string;
    link?: string;
  };
}

const IconWithTooltip: React.FC<IconWithTooltipProps> = ({
  disabled = false,
  placement = 'bottom',
  className,
  icon,
  onClick,
  tooltipProps
}) => {
  const cx = classnames.bind(styles);
  const finalClassName = cx('iconWithTooltip', className, {
    disabled
  });
  const props = {
    className: finalClassName,
    icon,
    onClick: disabled ? undefined : onClick
  };
  return tooltipProps ? (
    <OverlayTrigger
      placement={placement}
      trigger={['hover', 'focus']}
      overlay={
        <Tooltip id={tooltipProps.id + '-iconTooltip'}>
          {tooltipProps.tooltip}
        </Tooltip>
      }
    >
      {tooltipProps.link && !disabled ? (
        <Link to={tooltipProps.link}>
          <FontAwesomeIcon {...props} />
        </Link>
      ) : (
        <FontAwesomeIcon {...props} />
      )}
    </OverlayTrigger>
  ) : (
    <FontAwesomeIcon {...props} />
  );
};

export default IconWithTooltip;
